import { forwardRef, LegacyRef, InputHTMLAttributes } from 'react'
import { cn } from '../../utils'

export type InputProps = InputHTMLAttributes<
	HTMLInputElement | HTMLTextAreaElement
> & {
	id: string
	className?: string
	label?: string
	type?: string
}

const WrapperBaseClass = 'flex flex-col mt-4 gap-2'

export const Input = forwardRef<
	HTMLInputElement | HTMLTextAreaElement,
	InputProps
>(({ id, className, label, type, ...rest }, ref) => {
	return (
		<div className={cn(WrapperBaseClass, className)}>
			{!!label && (
				<label htmlFor={id} className="ml-2 text-sm">
					{label}
				</label>
			)}
			{type === 'textarea' ? (
				<textarea
					ref={ref as LegacyRef<HTMLTextAreaElement>}
					id={id}
					className="px-2 py-4 rounded-3xl focus:ring-0 focus:outline-none bg-white"
					{...rest}
				/>
			) : (
				<input
					ref={ref as LegacyRef<HTMLInputElement>}
					id={id}
					type={type}
					className="px-2 py-4 rounded-full focus:ring-0 focus:outline-none bg-white"
					{...rest}
				/>
			)}
		</div>
	)
})

Input.displayName = 'Input'
